"use client";

import { useRouter, useSearchParams } from "next/navigation";
import CategoryButton from "./categoryButton";

const Search = () => {
    const searchParams = useSearchParams();
    const router = useRouter();

    const handleSearch = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const formData = new FormData(e.currentTarget);
        const query = formData.get("query") as string;
        const params = new URLSearchParams(searchParams.toString());
        
        if (query) {
            params.set("query", query);
        } else {
            params.delete("query");
        }
        
        router.push(`?${params.toString()}`);
    };

    return (
        <div className="bg-gray-200 p-4 py-12 space-y-8">
            <div className="max-w-5xl mx-auto">
                <form onSubmit={handleSearch} className="flex items-center gap-6 max-w-2xl">
                    <input 
                        type="text" 
                        name="query"
                        defaultValue={searchParams.get("query")?.toString()}
                        className="w-full p-2 px-6 border-none rounded-full focus:outline-none focus:ring-2 focus:ring-wosm-default bg-white placeholder:text-gray-500"  
                        placeholder="Buscar" 
                        autoComplete="off" 
                        autoCorrect="off" 
                        autoCapitalize="off" 
                    />
                    <button type="submit" className="p-2 rounded-full bg-wosm-default hover:bg-wosm-default/80 transition-colors text-white px-6 font-semibold">BUSCAR</button>
                </form>
            </div>
            <div className="max-w-5xl mx-auto">
                <div className="flex flex-wrap items-center gap-2 md:gap-4">
                    <CategoryButton category="">Todo</CategoryButton>
                    <CategoryButton category="featured">🔥 Destacado</CategoryButton>
                    <CategoryButton category="guias-msu">Programa</CategoryButton>
                    <CategoryButton category="recursos-omms">Recursos OMMS</CategoryButton>
                    <CategoryButton category="eventos">Eventos</CategoryButton>
                 <CategoryButton category="memorias-y-balances">Documentos Institucionales</CategoryButton>
                 <CategoryButton category="otros">Otros</CategoryButton>
                </div>
                
                <p className="my-4 text-gray-500">¿Tienes algo increible en mente? <a href="https://forms.office.com/r/dYZdZDNLEQ" target="_blank" className="text-wosm-default hover:underline">¡Compártelo!</a></p>
            </div>
        </div>
    );
};

export default Search;